import React from 'react';
import {useAuth0} from '../../app/Auth0';
import {AUTH0_RETURN_TO} from '../../../configuration';

const AppLogin = () => {
	const {isAuthenticated, loginWithRedirect, logout} = useAuth0();

	if (!isAuthenticated) return <button type="button" onClick={() => loginWithRedirect({})}>Afmelden</button>;
	return <button type="button" onClick={() => logout({logoutParams: {returnTo: AUTH0_RETURN_TO}})}>Afmelden</button>;
};

export default AppLogin;
